import { render, staticRenderFns } from "./BSPagination.vue?vue&type=template&id=454bae82&scoped=true"
import script from "./BSPagination.vue?vue&type=script&lang=js"
export * from "./BSPagination.vue?vue&type=script&lang=js"
import style0 from "./BSPagination.vue?vue&type=style&index=0&id=454bae82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454bae82",
  null
  
)

export default component.exports